<template>
  <div class="container">
    <el-carousel v-show="language === 'zh-CN'" arrow="hover" class="banner" :autoplay="true" interval="5000" :pause-on-hover="true">
      <div v-if="!isMobile">
        <el-carousel-item>
          <img src="./images/bg1.png" :alt="$t('home.banner1')" class="banner-img">
        </el-carousel-item>
        <el-carousel-item>
          <div class="banner-btn home-btn-1" @click="toPage('/platformCloud')">{{ $t('home.getSolution') }}</div>
          <img src="./images/bg2.png" :alt="$t('home.banner2')" class="banner-img">
        </el-carousel-item>
        <el-carousel-item>
          <div class="banner-btn home-btn-2" @click="toPage('/platform')">{{ $t('home.getSolution') }}</div>
          <img src="./images/bg3.png" :alt="$t('home.banner3')" class="banner-img">
        </el-carousel-item>
        <el-carousel-item>
          <a class="home-btn" target="_blank" href="https://www.cheyifu.com.cn/cloud/login">{{ $t('home.tryExperience') }}</a>
          <img src="./images/bg4.png" :alt="$t('home.banner4Alt')" class="banner-img">
        </el-carousel-item>
      </div>
      <div v-else>
         <el-carousel-item>
          <img src="./images/bg-mobile.png" :alt="$t('home.banner1')" class="banner-img">
        </el-carousel-item>
      </div>
    </el-carousel>
    <el-carousel v-show="language === 'en-US'" arrow="hover" class="banner" :autoplay="true" interval="5000" :pause-on-hover="true">
      <el-carousel-item v-if="!isMobile">
        <img src="./images/bg-en.png" :alt="$t('home.banner1')" class="banner-img">
      </el-carousel-item>
      <el-carousel-item v-else>
        <img src="./images/bg-en-mobile.png" :alt="$t('home.banner1')" class="banner-img">
      </el-carousel-item>
    </el-carousel>
    <div class="section1">
      <!-- <div class="flex-between section-padding">
        <div class="section1-item flex-column">
          <div class="flex-center">
            <countUp class="section1-item-num" :startVal="0" :endVal="1.12" :duration='5' :options="{ decimalPlaces: 2 }"></countUp>
            <div class="section1-item-unit">亿+</div>
          </div>
          <div class="">年销售额</div>
        </div>
        <div class="section1-item flex-column">
          <div class="flex-center">
            <countUp class="section1-item-num" :startVal="0" :endVal="160" :duration='5'></countUp>
            <div class="section1-item-unit">+</div>
          </div>
          <div class="">覆盖城市</div>
        </div>
        <div class="section1-item flex-column">
          <div class="flex-center">
            <countUp class="section1-item-num" :startVal="100" :endVal="500" :duration='5'></countUp>
            <div class="section1-item-unit">+</div>
          </div>
          <div class="">服务项目</div>
        </div>
        <div class="section1-item flex-column">
          <div class="flex-center">
            <countUp class="section1-item-num" :startVal="0" :endVal="40" :duration='5'></countUp>
            <div class="section1-item-unit">+</div>
          </div>
          <div class="">资质证书</div>
        </div>
      </div> -->
      <div class="flex-between home-large-padding">
        <el-row>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <div class="section2-item-text">
              <div class="company-title">{{ $t('home.companyIntro') }}</div>
              <div class="company-detail">
                <h1 style="font-weight:400;font-size:16px">
                  {{ $t('home.companyDetail') }}
                </h1>
              </div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <div class="section2-item-img-1">
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="section2">
      <div class="home-section-title">{{ $t('home.ourProducts') }}</div>
      <div class="section2-content">
        <el-carousel v-if="isMobile" arrow="hover" indicator-position="none"
          style="width: 92vw;height:55.6vh;">
          <el-carousel-item>
            <div class="section2-inner-item">
              <div class="section2-inner-content">
                <div class="section2-inner-item-top section2-inner-item-top-1" :class="{'section2-inner-item-top-en-US': language == 'en-US', 'section2-inner-item-top-mobile': isMobile}">
                  <h2 class="section2-inner-item-title">{{ $t('home.parkingService') }}</h2>
                  <h3 class="section2-inner-item-title-desc">{{ $t('home.parkingDesc') }}</h3>
                </div>
                <div v-show="language == 'zh-CN'" class="section2-inner-item-bot">
                  <div class="section2-inner-item-btn">{{ $t('home.serviceAdvantage') }}</div>
                  <div>
                    <h3 class="section2-inner-item-detail">{{ $t('home.servicePoint1') }}</h3>
                    <h3 class="section2-inner-item-detail">{{ $t('home.servicePoint2') }}</h3>
                    <h3 class="section2-inner-item-detail">{{ $t('home.servicePoint3') }}</h3>
                  </div>
                </div>
              </div>
              <div class="section2-inner-bg">
                <div class="section2-inner-item-top section2-inner-item-top-1" :class="{'section2-inner-item-top-en-US': language == 'en-US', 'section2-inner-item-top-mobile': isMobile}">
                  <h2 class="section2-inner-item-title">{{ $t('home.parkingService') }}</h2>
                  <h3 class="section2-inner-item-title-desc">{{ $t('home.parkingDesc') }}</h3>
                </div>
                <div v-show="language == 'zh-CN'" class="section2-inner-item-bot">
                  <div class="section2-inner-item-btn">{{ $t('home.serviceAdvantage') }}</div>
                  <div>
                    <h3 class="section2-inner-item-detail">{{ $t('home.servicePoint1') }}</h3>
                    <h3 class="section2-inner-item-detail">{{ $t('home.servicePoint2') }}</h3>
                    <h3 class="section2-inner-item-detail">{{ $t('home.servicePoint3') }}</h3>
                  </div>
                </div>
              </div>
            </div>
          </el-carousel-item>
          <el-carousel-item>
            <div class="section2-inner-item">
              <div class="section2-inner-content">
                <div class="section2-inner-item-top section2-inner-item-top-1" :class="{'section2-inner-item-top-en-US': language == 'en-US', 'section2-inner-item-top-mobile': isMobile}">
                  <h2 class="section2-inner-item-title">{{ $t('home.roadsideParking') }}</h2>
                  <h3 class="section2-inner-item-title-desc">{{ $t('home.roadsideParkingDesc') }}</h3>
                </div>
                <div v-show="language == 'zh-CN'" class="section2-inner-item-bot">
                  <div class="section2-inner-item-btn">{{ $t('home.serviceAdvantage') }}</div>
                  <div>
                    <h3 class="section2-inner-item-detail">{{ $t('home.roadsideAdvantage1') }}</h3>
                    <h3 class="section2-inner-item-detail">{{ $t('home.roadsideAdvantage2') }}</h3>
                    <h3 class="section2-inner-item-detail">{{ $t('home.roadsideAdvantage3') }}</h3>
                  </div>
                </div>
              </div>
              <div class="section2-inner-bg">
                <div class="section2-inner-item-top section2-inner-item-top-1" :class="{'section2-inner-item-top-en-US': language == 'en-US', 'section2-inner-item-top-mobile': isMobile}">
                  <h2 class="section2-inner-item-title">{{ $t('home.roadsideParking') }}</h2>
                  <h3 class="section2-inner-item-title-desc">{{ $t('home.roadsideParkingDesc') }}</h3>
                </div>
                <div v-show="language == 'zh-CN'" class="section2-inner-item-bot">
                  <div class="section2-inner-item-btn">{{ $t('home.serviceAdvantage') }}</div>
                  <div>
                    <h3 class="section2-inner-item-detail">{{ $t('home.roadsideAdvantage1') }}</h3>
                    <h3 class="section2-inner-item-detail">{{ $t('home.roadsideAdvantage2') }}</h3>
                    <h3 class="section2-inner-item-detail">{{ $t('home.roadsideAdvantage3') }}</h3>
                  </div>
                </div>
              </div>

            </div>
          </el-carousel-item>
          <el-carousel-item>
            <div class="section2-inner-item">
              <div class="section2-inner-content">
                <div class="section2-inner-item-top section2-inner-item-top-2" :class="{'section2-inner-item-top-en-US': language == 'en-US', 'section2-inner-item-top-mobile': isMobile}">
                  <h2 class="section2-inner-item-title">{{ $t('home.chargingService') }}</h2>
                  <h3 class="section2-inner-item-title-desc">{{ $t('home.chargingServiceDesc') }}</h3>
                </div>
                <div v-show="language == 'zh-CN'" class="section2-inner-item-bot">
                  <div class="section2-inner-item-btn">{{ $t('home.serviceAdvantage') }}</div>
                  <div>
                    <h3 class="section2-inner-item-detail">{{ $t('home.chargingAdvantage1') }}</h3>
                    <h3 class="section2-inner-item-detail">{{ $t('home.chargingAdvantage2') }}</h3>
                    <h3 class="section2-inner-item-detail">{{ $t('home.chargingAdvantage3') }}</h3>
                  </div>
                </div>
              </div>
              <div class="section2-inner-bg">
                <div class="section2-inner-item-top section2-inner-item-top-2" :class="{'section2-inner-item-top-en-US': language == 'en-US', 'section2-inner-item-top-mobile': isMobile}">
                  <h2 class="section2-inner-item-title">{{ $t('home.chargingService') }}</h2>
                  <h3 class="section2-inner-item-title-desc">{{ $t('home.chargingServiceDesc') }}</h3>
                </div>
                <div v-show="language == 'zh-CN'" class="section2-inner-item-bot">  
                  <div class="section2-inner-item-btn">{{ $t('home.serviceAdvantage') }}</div>
                  <div>
                    <h3 class="section2-inner-item-detail">{{ $t('home.chargingAdvantage1') }}</h3>
                    <h3 class="section2-inner-item-detail">{{ $t('home.chargingAdvantage2') }}</h3>
                    <h3 class="section2-inner-item-detail">{{ $t('home.chargingAdvantage3') }}</h3>
                  </div>
                </div>
              </div>
            </div>
          </el-carousel-item>
          <el-carousel-item>
            <div class="section2-inner-item">
              <div class="section2-inner-content">
                <div class="section2-inner-item-top section2-inner-item-top-3" :class="{'section2-inner-item-top-en-US': language == 'en-US', 'section2-inner-item-top-mobile': isMobile}">
                  <h2 class="section2-inner-item-title">{{ $t('home.accessControlService') }}</h2>
                  <h3 class="section2-inner-item-title-desc">{{ $t('home.accessControlServiceDesc') }}</h3>
                </div>
                <div v-show="language == 'zh-CN'" class="section2-inner-item-bot">
                  <div class="section2-inner-item-btn">{{ $t('home.serviceAdvantage') }}</div>
                  <div>
                    <h3 class="section2-inner-item-detail">{{ $t('home.accessControlAdvantage1') }}</h3>
                    <h3 class="section2-inner-item-detail">{{ $t('home.accessControlAdvantage2') }}</h3>
                    <h3 class="section2-inner-item-detail">{{ $t('home.accessControlAdvantage3') }}</h3>
                  </div>
                </div>
              </div>
              <div class="section2-inner-bg">
                <div class="section2-inner-item-top section2-inner-item-top-3" :class="{'section2-inner-item-top-en-US': language == 'en-US', 'section2-inner-item-top-mobile': isMobile}">
                  <h2 class="section2-inner-item-title">{{ $t('home.accessControlService') }}</h2>
                  <h3 class="section2-inner-item-title-desc">{{ $t('home.accessControlServiceDesc') }}</h3>
                </div>
                <div v-show="language == 'zh-CN'" class="section2-inner-item-bot">
                  <div class="section2-inner-item-btn">{{ $t('home.serviceAdvantage') }}</div>
                  <div>
                    <h3 class="section2-inner-item-detail">{{ $t('home.accessControlAdvantage1') }}</h3>
                    <h3 class="section2-inner-item-detail">{{ $t('home.accessControlAdvantage2') }}</h3>
                    <h3 class="section2-inner-item-detail">{{ $t('home.accessControlAdvantage3') }}</h3>
                  </div>
                </div>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
        <div v-if="!isMobile" class="section2-wrap">
          <div class="section2-inner" id="section2-inner">
            <div class="section2-inner-item">
              <div class="section2-inner-content">
                <div class="section2-inner-item-top section2-inner-item-top-1" :class="{'section2-inner-item-top-en-US': language == 'en-US'}">
                  <h2 class="section2-inner-item-title">{{ $t('home.parkingService') }}</h2>
                  <h3 class="section2-inner-item-title-desc">{{ $t('home.parkingDesc') }}</h3>
                </div>
                <div v-show="language == 'zh-CN'" class="section2-inner-item-bot">
                  <div class="section2-inner-item-btn">{{ $t('home.serviceAdvantage') }}</div>
                  <div>
                    <h3 class="section2-inner-item-detail">{{ $t('home.servicePoint1') }}</h3>
                    <h3 class="section2-inner-item-detail">{{ $t('home.servicePoint2') }}</h3>
                    <h3 class="section2-inner-item-detail">{{ $t('home.servicePoint3') }}</h3>
                  </div>
                </div>
              </div>
              <div class="section2-inner-bg">
                <div class="section2-inner-item-top section2-inner-item-top-1" :class="{'section2-inner-item-top-en-US': language == 'en-US'}">
                  <h2 class="section2-inner-item-title">{{ $t('home.parkingService') }}</h2>
                  <h3 class="section2-inner-item-title-desc">{{ $t('home.parkingDesc') }}</h3>
                </div>
                <div v-show="language == 'zh-CN'" class="section2-inner-item-bot">
                  <div class="section2-inner-item-btn">{{ $t('home.serviceAdvantage') }}</div>
                  <div>
                    <h3 class="section2-inner-item-detail">{{ $t('home.servicePoint1') }}</h3>
                    <h3 class="section2-inner-item-detail">{{ $t('home.servicePoint2') }}</h3>
                    <h3 class="section2-inner-item-detail">{{ $t('home.servicePoint3') }}</h3>
                  </div>
                </div>
              </div>
            </div>
            <div class="section2-inner-item">
              <div class="section2-inner-content">
                <div class="section2-inner-item-top section2-inner-item-top-1" :class="{'section2-inner-item-top-en-US': language == 'en-US'}">
                  <h2 class="section2-inner-item-title">{{ $t('home.roadsideParking') }}</h2>
                  <h3 class="section2-inner-item-title-desc">{{ $t('home.roadsideParkingDesc') }}</h3>
                </div>
                <div v-show="language == 'zh-CN'" class="section2-inner-item-bot">
                  <div class="section2-inner-item-btn">{{ $t('home.serviceAdvantage') }}</div>
                  <div>
                    <h3 class="section2-inner-item-detail">{{ $t('home.roadsideAdvantage1') }}</h3>
                    <h3 class="section2-inner-item-detail">{{ $t('home.roadsideAdvantage2') }}</h3>
                    <h3 class="section2-inner-item-detail">{{ $t('home.roadsideAdvantage3') }}</h3>
                  </div>
                </div>
              </div>
              <div class="section2-inner-bg">
                <div class="section2-inner-item-top section2-inner-item-top-1" :class="{'section2-inner-item-top-en-US': language == 'en-US'}">
                  <h2 class="section2-inner-item-title">{{ $t('home.roadsideParking') }}</h2>
                  <h3 class="section2-inner-item-title-desc">{{ $t('home.roadsideParkingDesc') }}</h3>
                </div>
                <div v-show="language == 'zh-CN'" class="section2-inner-item-bot">
                  <div class="section2-inner-item-btn">{{ $t('home.serviceAdvantage') }}</div>
                  <div>
                    <h3 class="section2-inner-item-detail">{{ $t('home.roadsideAdvantage1') }}</h3>
                    <h3 class="section2-inner-item-detail">{{ $t('home.roadsideAdvantage2') }}</h3>
                    <h3 class="section2-inner-item-detail">{{ $t('home.roadsideAdvantage3') }}</h3>
                  </div>
                </div>
              </div>

            </div>
            <div class="section2-inner-item">
              <div class="section2-inner-content">
                <div class="section2-inner-item-top section2-inner-item-top-2" :class="{'section2-inner-item-top-en-US': language == 'en-US'}">
                  <h2 class="section2-inner-item-title">{{ $t('home.chargingService') }}</h2>
                  <h3 class="section2-inner-item-title-desc">{{ $t('home.chargingServiceDesc') }}</h3>
                </div>
                <div v-show="language == 'zh-CN'" class="section2-inner-item-bot">
                  <div class="section2-inner-item-btn">{{ $t('home.serviceAdvantage') }}</div>
                  <div>
                    <h3 class="section2-inner-item-detail">{{ $t('home.chargingAdvantage1') }}</h3>
                    <h3 class="section2-inner-item-detail">{{ $t('home.chargingAdvantage2') }}</h3>
                    <h3 class="section2-inner-item-detail">{{ $t('home.chargingAdvantage3') }}</h3>
                  </div>
                </div>
              </div>
              <div class="section2-inner-bg">
                <div class="section2-inner-item-top section2-inner-item-top-2" :class="{'section2-inner-item-top-en-US': language == 'en-US'}">
                  <h2 class="section2-inner-item-title">{{ $t('home.chargingService') }}</h2>
                  <h3 class="section2-inner-item-title-desc">{{ $t('home.chargingServiceDesc') }}</h3>
                </div>
                <div v-show="language == 'zh-CN'" class="section2-inner-item-bot">
                  <div class="section2-inner-item-btn">{{ $t('home.serviceAdvantage') }}</div>
                  <div>
                    <h3 class="section2-inner-item-detail">{{ $t('home.chargingAdvantage1') }}</h3>
                    <h3 class="section2-inner-item-detail">{{ $t('home.chargingAdvantage2') }}</h3>
                    <h3 class="section2-inner-item-detail">{{ $t('home.chargingAdvantage3') }}</h3>
                  </div>
                </div>
              </div>
            </div>
            <div class="section2-inner-item">
              <div class="section2-inner-content">
                <div class="section2-inner-item-top section2-inner-item-top-3" :class="{'section2-inner-item-top-en-US': language == 'en-US'}">
                  <h2 class="section2-inner-item-title">{{ $t('home.accessControlService') }}</h2>
                  <h3 class="section2-inner-item-title-desc">{{ $t('home.accessControlServiceDesc') }}</h3>
                </div>
                <div v-show="language == 'zh-CN'" class="section2-inner-item-bot">
                  <div class="section2-inner-item-btn">{{ $t('home.serviceAdvantage') }}</div>
                  <div>
                    <h3 class="section2-inner-item-detail">{{ $t('home.accessControlAdvantage1') }}</h3>
                    <h3 class="section2-inner-item-detail">{{ $t('home.accessControlAdvantage2') }}</h3>
                    <h3 class="section2-inner-item-detail">{{ $t('home.accessControlAdvantage3') }}</h3>
                  </div>
                </div>
              </div>
              <div class="section2-inner-bg">
                <div class="section2-inner-item-top section2-inner-item-top-3" :class="{'section2-inner-item-top-en-US': language == 'en-US'}">
                  <h2 class="section2-inner-item-title">{{ $t('home.accessControlService') }}</h2>
                  <h3 class="section2-inner-item-title-desc">{{ $t('home.accessControlServiceDesc') }}</h3>
                </div>
                <div v-show="language == 'zh-CN'" class="section2-inner-item-bot">
                  <div class="section2-inner-item-btn">{{ $t('home.serviceAdvantage') }}</div>
                  <div>
                    <h3 class="section2-inner-item-detail">{{ $t('home.accessControlAdvantage1') }}</h3>
                    <h3 class="section2-inner-item-detail">{{ $t('home.accessControlAdvantage2') }}</h3>
                    <h3 class="section2-inner-item-detail">{{ $t('home.accessControlAdvantage3') }}</h3>
                  </div>
                </div>
              </div>
            </div>
            <div class="section2-inner-item">
              <div class="section2-inner-content">
                <div class="section2-inner-item-top section2-inner-item-top-4" :class="{'section2-inner-item-top-en-US': language == 'en-US'}">
                  <h2 class="section2-inner-item-title">{{ $t('home.parkingService') }}</h2>
                  <h3 class="section2-inner-item-title-desc">{{ $t('home.parkingDesc') }}</h3>
                </div>
                <div v-show="language == 'zh-CN'" class="section2-inner-item-bot">
                  <div class="section2-inner-item-btn">{{ $t('home.serviceAdvantage') }}</div>
                  <div>
                    <h3 class="section2-inner-item-detail">{{ $t('home.servicePoint1') }}</h3>
                    <h3 class="section2-inner-item-detail">{{ $t('home.servicePoint2') }}</h3>
                    <h3 class="section2-inner-item-detail">{{ $t('home.servicePoint3') }}</h3>
                  </div>
                </div>
              </div>
              <div class="section2-inner-bg">
                <div class="section2-inner-item-top section2-inner-item-top-4" :class="{'section2-inner-item-top-en-US': language == 'en-US'}">
                  <h2 class="section2-inner-item-title">{{ $t('home.parkingService') }}</h2>
                  <h3 class="section2-inner-item-title-desc">{{ $t('home.parkingDesc') }}</h3>
                </div>
                <div v-show="language == 'zh-CN'" class="section2-inner-item-bot">
                  <div class="section2-inner-item-btn">{{ $t('home.serviceAdvantage') }}</div>
                  <div>
                    <h3 class="section2-inner-item-detail">{{ $t('home.servicePoint1') }}</h3>
                    <h3 class="section2-inner-item-detail">{{ $t('home.servicePoint2') }}</h3>
                    <h3 class="section2-inner-item-detail">{{ $t('home.servicePoint3') }}</h3>
                  </div>
                </div>
              </div>
            </div>
            <div class="section2-inner-item">
              <div class="section2-inner-content">
                <div class="section2-inner-item-top section2-inner-item-top-1" :class="{'section2-inner-item-top-en-US': language == 'en-US'}">
                  <h2 class="section2-inner-item-title">{{ $t('home.roadsideParking') }}</h2>
                  <h3 class="section2-inner-item-title-desc">{{ $t('home.roadsideParkingDesc') }}</h3>
                </div>
                <div v-show="language == 'zh-CN'" class="section2-inner-item-bot">
                  <div class="section2-inner-item-btn">{{ $t('home.serviceAdvantage') }}</div>
                  <div>
                    <h3 class="section2-inner-item-detail">{{ $t('home.roadsideAdvantage1') }}</h3>
                    <h3 class="section2-inner-item-detail">{{ $t('home.roadsideAdvantage2') }}</h3>
                    <h3 class="section2-inner-item-detail">{{ $t('home.roadsideAdvantage3') }}</h3>
                  </div>
                </div>
              </div>
              <div class="section2-inner-bg">
                <div class="section2-inner-item-top section2-inner-item-top-1" :class="{'section2-inner-item-top-en-US': language == 'en-US'}">
                  <h2 class="section2-inner-item-title">{{ $t('home.roadsideParking') }}</h2>
                  <h3 class="section2-inner-item-title-desc">{{ $t('home.roadsideParkingDesc') }}</h3>
                </div>
                <div v-show="language == 'zh-CN'" class="section2-inner-item-bot">
                  <div class="section2-inner-item-btn">{{ $t('home.serviceAdvantage') }}</div>
                  <div>
                    <h3 class="section2-inner-item-detail">{{ $t('home.roadsideAdvantage1') }}</h3>
                    <h3 class="section2-inner-item-detail">{{ $t('home.roadsideAdvantage2') }}</h3>
                    <h3 class="section2-inner-item-detail">{{ $t('home.roadsideAdvantage3') }}</h3>
                  </div>
                </div>
              </div>

            </div>
            <div class="section2-inner-item">
              <div class="section2-inner-content">
                <div class="section2-inner-item-top section2-inner-item-top-2" :class="{'section2-inner-item-top-en-US': language == 'en-US'}">
                  <h2 class="section2-inner-item-title">{{ $t('home.chargingService') }}</h2>
                  <h3 class="section2-inner-item-title-desc">{{ $t('home.chargingServiceDesc') }}</h3>
                </div>
                <div v-show="language == 'zh-CN'" class="section2-inner-item-bot">
                  <div class="section2-inner-item-btn">{{ $t('home.serviceAdvantage') }}</div>
                  <div>
                    <h3 class="section2-inner-item-detail">{{ $t('home.chargingAdvantage1') }}</h3>
                    <h3 class="section2-inner-item-detail">{{ $t('home.chargingAdvantage2') }}</h3>
                    <h3 class="section2-inner-item-detail">{{ $t('home.chargingAdvantage3') }}</h3>
                  </div>
                </div>
              </div>
              <div class="section2-inner-bg">
                <div class="section2-inner-item-top section2-inner-item-top-2" :class="{'section2-inner-item-top-en-US': language == 'en-US'}">
                  <h2 class="section2-inner-item-title">{{ $t('home.chargingService') }}</h2>
                  <h3 class="section2-inner-item-title-desc">{{ $t('home.chargingServiceDesc') }}</h3>
                </div>
                <div v-show="language == 'zh-CN'" class="section2-inner-item-bot">
                  <div class="section2-inner-item-btn">{{ $t('home.serviceAdvantage') }}</div>
                  <div>
                    <h3 class="section2-inner-item-detail">{{ $t('home.chargingAdvantage1') }}</h3>
                    <h3 class="section2-inner-item-detail">{{ $t('home.chargingAdvantage2') }}</h3>
                    <h3 class="section2-inner-item-detail">{{ $t('home.chargingAdvantage3') }}</h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="section2-controler">
            <div class="section2-arrow-left section2-arrow" @click="handlePre"></div>
            <div class="section2-arrow" @click="handleNext"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="section3">
      <div class="home-section-title">{{ $t('home.smartHardware') }}</div>
      <div class="flex-center section3-indicator">
        <div class="section3-indicator-item" :class="{'section3-indicator-active':section3Index===0}"
          @click="changeCard(0)">{{ $t('home.parkingLot') }}</div>
        <div class="section3-indicator-item" :class="{'section3-indicator-active':section3Index===1}"
          @click="changeCard(1)">{{ $t('home.chargingEnergy') }}</div>
        <div class="section3-indicator-item" :class="{'section3-indicator-active':section3Index===2}"
          @click="changeCard(2)">{{ $t('home.accessControlHardware') }}</div>
      </div>
      <div class="flex-between home-large-padding">
        <el-carousel ref="carousel" indicator-position="none" arrow="never" style="width:100%;height:47.4vh;"
          @change="handleCardChange">
          <el-carousel-item>
            <div class="section3-card">
              <h2 class="section3-card-title">{{ $t('home.parkingHardware') }}</h2>
              <div class="section3-card-sub" v-show="language == 'zh-CN'">{{ $t('home.ownPlatform') }}</div>
              <div class="section3-card-sub" v-show="language == 'zh-CN'">{{ $t('home.ownHardware') }}</div>
              <h3 class="section3-card-con">
                {{ $t('home.parkingHardwareDesc') }}
              </h3>
              <div class="home-btn" @click="toPage('/productClose')">{{ $t('home.learnMore') }}</div>
            </div>
          </el-carousel-item>
          <el-carousel-item>
            <div class="section3-card section3-card-2">
              <h2 class="section3-card-title">{{ $t('home.chargingHardware') }}</h2>
              <div class="section3-card-sub" v-show="language == 'zh-CN'">{{ $t('home.ownPlatform') }}</div>
              <div class="section3-card-sub" v-show="language == 'zh-CN'">{{ $t('home.ownHardware') }}</div>
              <h3 class="section3-card-con">
                {{ $t('home.chargingHardwareDesc') }}
              </h3>
              <div class="home-btn" @click="toPage('/productChargeHw')">{{ $t('home.learnMore') }}</div>
            </div>
          </el-carousel-item>
          <el-carousel-item>
            <div class="section3-card section3-card-3">
              <h2 class="section3-card-title">{{ $t('home.accessControlHardware') }}</h2>
              <div class="section3-card-sub" v-show="language == 'zh-CN'">{{ $t('home.ownPlatform') }}</div>
              <div class="section3-card-sub" v-show="language == 'zh-CN'">{{ $t('home.ownHardware') }}</div>
              <h3 class="section3-card-con">
                {{ $t('home.accessControlHardwareDesc') }}
              </h3>
              <div class="home-btn" @click="toPage('/productAcs')">{{ $t('home.learnMore') }}</div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <div class="section4">
      <h2 class="home-section-title">{{ $t('home.customerTrust') }}</h2>
      <el-row class="section4-con home-large-padding" :gutter="40">
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <div class="section4-item section4-item-1">
            <div class="section4-card section4-card-1">
              <h3 class="section4-card-title">{{ $t('home.jiamusiProject') }}</h3>
              <p class="section4-card-con">{{ $t('home.jiamusiProjectDesc') }}</p>
              <div class="section4-card-bot">
                <div class="section4-card-line"></div>
                <div>{{ $t('home.heilongjiang') }}</div>
              </div>
              <div class="home-btn section4-card-btn" @click="toCaseDetail(1)">{{ $t('home.learnMore') }}</div>
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <div class="section4-item">
            <div class="section4-card section4-card-2">
              <h3 class="section4-card-title">{{ $t('home.guiyangProject') }}</h3>
              <p class="section4-card-con">{{ $t('home.guiyangProjectDesc') }}</p>
              <div class="section4-card-bot">
                <div class="section4-card-line"></div>
                <div>{{ $t('home.guizhou') }}</div>
              </div>
              <div class="home-btn section4-card-btn" @click="toCaseDetail(2)">{{ $t('home.learnMore') }}</div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- <div class="section5">
      <div class="home-section-title">专业的合作伙伴</div>
      <div class="section5-con">
        <div class="section-img"></div>
      </div>
    </div> -->
  </div>
</template>
<script>
  import { ElCarousel, ElCarouselItem, ElRow, ElCol } from 'element-plus'
  import { mapState } from 'vuex'
  // import countUp from 'vue-countup-v3';
  import news from './../news/data.js'
  let timer;

  export default {
    components: { ElCarousel, ElCarouselItem, ElRow, ElCol },
    computed: {
      ...mapState(['isMobile'])
    },
    data() {
      return {
        new1: '',
        new2: '',
        clientWidth: '',
        section3Index: 2,
        language: '',
      }
    },
    created() {
      this.clientWidth = document.body.clientWidth;
      this.new1 = news[0]
      this.new2 = news[1]
    },
    mounted() {
      if (!this.isMobile) {
        this.init()
      }
      this.language = this.$i18n.locale
    },
    beforeDestroy() {
      timer && clearInterval(timer)
    },
    methods: {
      toPage(url) {
        this.$router.push(url)
      },
      toCaseDetail(id) {
        window.localStorage.setItem('casesId', id)
        this.$router.push("/cases-detail")
      },
      init() {
        const clientWidth = document.body.clientWidth;
        const section2 = document.getElementById('section2-inner')
        timer = setInterval(() => {
          const leftOffset = section2.offsetLeft;
          const left = (leftOffset) - clientWidth * 0.364
          if (left < - clientWidth * 0.364 * 4) {
            section2.style.transition = 'none'
            section2.style.left = `-${clientWidth * 0.364}px`
          } else {
            section2.style.left = `${left}px`
            section2.style.transition = 'all 0.3s linear';
          }
        }, 2500)
      },
      changeCard(type) {
        // 手动切换智能化硬件产品
        this.section3Index = type
        this.$refs.carousel.setActiveItem(type)
      },
      handleCardChange() {
        // 自动切换智能化硬件产品
        this.section3Index = this.$refs.carousel.activeIndex
      },
      handlePre() {
        timer && clearInterval(timer)
        const clientWidth = document.body.clientWidth;
        const section2 = document.getElementById('section2-inner')
        const leftOffset = section2.offsetLeft;
        const left = (leftOffset) - clientWidth * 0.364
        if (left < - clientWidth * 0.364 * 4) {
          section2.style.transition = 'none'
          section2.style.left = `-${clientWidth * 0.364}px`
        } else {
          section2.style.left = `${left}px`
          section2.style.transition = 'all 0.3s linear';
        }
        this.init()
      },
      handleNext() {
        timer && clearInterval(timer)
        const clientWidth = document.body.clientWidth;
        const section2 = document.getElementById('section2-inner')
        const leftOffset = section2.offsetLeft;
        const left = (leftOffset) + clientWidth * 0.364
        if (left > - clientWidth * 0.364) {
          section2.style.transition = 'none'
          section2.style.left = `-${clientWidth * 0.364 * 4}px`
        } else {
          section2.style.left = `${left}px`
          section2.style.transition = 'all 0.3s linear';
        }
      },
      getTranslateX(element) {
        const style = window.getComputedStyle(element);
        const transform = style.transform;

        if (transform.includes('translateX')) {
          const match = transform.match(/translateX\(([^)]+)px\)/);
          if (match) {
            return parseFloat(match[1]);
          }
        }

        return 0;
      }

    }
  }

</script>
<style lang="less" scoped>
  .banner,
  .banner .el-carousel-item {
    position: relative;
    padding: 7.4vh 0 0;
    width: 100%;
    color: #fff;
  }

  .home-btn,
  .banner-btn {
    background: #0F46FF;
    border-radius: 60px;
    font-weight: 700;
    font-size: 32px;
    color: #FFFFFF;
    text-align: center;
    cursor: pointer;
  }

  .home-btn:hover {
    background: #3F6BFF;
  }

  .home-btn-3:active {
    background: #0C38CC;
  }

  .home-btn-1 {
    background: #E63047;
  }

  .home-btn-2 {
    background: #F3C583;
    color: #5E3A06;
  }

  .banner .home-btn,
  .banner .banner-btn {
    position: absolute;
    left: 16.1vw;
    bottom: 12.3%;
  }


  @media (max-width: 768px) {
    .banner {
      height: 780px;
      /* 小屏幕高度 */
    }
    .banner .banner-img {
      height: 660px;
    }

    .home-large-padding {
      padding: 0 5vw;
    }

    .home-btn,
    .banner-btn {
      width: 280px;
      height: 68px;
      line-height: 66px;
    }

    .section2-inner-item {
      margin-top: 6.4vh;
      margin-right: 0;
      width: 100%;
    }

    .section2-item-text {
      padding-right: 0 !important;
    }

    .section2-content {
      position: relative;
      padding-left: 4vw;
      height: 48vh !important;
    }

    .section3-card {
      padding: 18vh 0 0 30px;
      background-position: top center;
      background-size: 100% 18vh;
    }

    /* .section3-card-2,.section3-card-3{
      background-size:100% 18vh;
    } */
    .section3-card-title {
      padding-bottom: 20px;
    }

    .section3-card-con {
      margin-bottom: 1vh;
    }

    .company-title {
      font-size: 64px !important;
      margin-top: 5vh;
    }
    .home-large-padding {
      padding: 0 10vw 0 !important;
    }
    .home-section-title {
      font-size: 64px !important;
      padding: 5vh 10vw !important;
    }
    .section3-card-title,.section4-card-title{
      font-size: 48px !important;
    }

    .section3-indicator{
      padding: 0 5vw;
    }

    .section4-con {
      gap: 20px;
    }
  }

  @media (min-width: 769px) {
    .banner {
      height: 33vw;
      /* 大屏幕高度 */
    }

    .home-large-padding {
      padding: 0 12.5vw 0;
    }

    .home-btn,
    .banner-btn {
      width: 480px;
      height: 100px;
      line-height: 100px;
    }

    .section2-inner-item {
      width: 32.2vw;
      min-width: 32.2vw;
    }

    .section3-card {
      padding: 0 51.9vw 0 2.6vw;
      background-position: right center;
      background-size: 49.3vw 100%;
    }

    .section3-card-2,
    .section3-card-3 {
      background-size: 49.3vw 100%;
    }

    .section3-card-title {
      padding-bottom: 4.4vh;
    }

    .section3-card-con {
      margin-bottom: 6.5vh;
    }


    .company-title {
      margin-top: 10.5vh;
    }
  }

  .banner-img {
    width: 100%;
    height: 100%;
  }

  .section5-con {
    position: relative;
    padding-bottom: 200px;
    width: 100%;
    height: 360px;
    background: #F7F8FA;
  }

  .section-img {
    position: absolute;
    left: 0;
    width: 2000%;
    height: 160px;
    background: #F7F8FA url(./images/section5.png);
    background-repeat: repeat-x;
    background-size: 7880px 100%;
    animation: marquee 600s linear infinite 0s;
  }

  @keyframes marquee {
    0% {
      transform: translateX(10);
    }

    100% {
      transform: translateX(-100%);
    }
  }

  .section4,
  .section3 {
    background: #F7F8FA;
  }

  .section4 {
    padding-bottom: 160px;

    &-con {
      position: relative;
    }

    &-item {
      position: relative;
      height: 45.6vh;
      background-color: #fff;
      border-radius: 16px;
      background: url(./images/section4-2.png) 0 0 no-repeat;
      background-size: 100% 29.8vh;
    }

    &-item-1 {
      background: url(./images/section4-1.png) 0 0 no-repeat;
      background-size: 100% 29.8vh;
    }

    &-card {
      position: absolute;
      left: 0;
      bottom: 0;
      padding: 0 60px;
      width: 100%;
      height: 18vh;
      font-size: 32px;
      background: #fff;
      border-radius: 16px;
      transition: all 0.3s ease-in-out 0s;
      overflow: hidden;
    }

    &-card:hover {
      height: 32.4vh;
    }

    &-card:hover .section4-card-con {
      text-wrap: wrap;
      margin-bottom: 40px;
    }

    &-card .section4-card-btn {
      opacity: 0;
      width: 0;
      transition: all 0.3s linear 0s;

    }

    &-card:hover .section4-card-btn {
      opacity: 1;
      width: 480px;
    }

    &-card-title {
      padding: 60px 0 40px;
      font-weight: 700;
      font-size: 48px;
    }


    &-card-con {
      text-overflow: ellipsis;
      text-wrap: nowrap;
      overflow: hidden;
    }

    &-card-bot {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      margin-top: 40px;
      font-weight: 700;
    }

    &-card-line {
      margin-right: 32px;
      width: 120px;
      height: 2px;
      background-color: #E5E6EB;
    }

    &-card-btn {
      margin: 40px auto;
    }

  }

  .section3 {
    &-card {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      height: 47.4vh;
      border-radius: 16px;
      background-repeat: no-repeat;
      background-color: #fff;
      background-image: url('./images/section3-1.png');
    }

    &-card-2 {
      background-image: url('./images/section3-2.png');
    }

    &-card-3 {
      background-image: url('./images/section3-3.png');
    }

    &-card-title {
      font-weight: 700;
      font-size: 60px;
    }

    &-card-sub {
      margin-bottom: 40px;
      padding-left: 60px;
      font-weight: 550;
      font-size: 36px;
      background: url(./images/section3-icon.png) left center no-repeat;
      background-size: 36px 36px;
    }

    &-card-con {
      font-size: 32px;
      color: #4E5969;
      line-height: 56px;
    }

    &-indicator {
      margin-bottom: 64px;
      color: #4E5969;
      font-size: 40px;
    }

    &-indicator-item {
      text-align: center;
      padding-bottom: 46px;
      cursor: pointer;
      border-bottom: 6px solid transparent;
    }

    &-indicator-item:nth-child(2) {
      margin: 0 12vw;
    }

    &-indicator-active {
      color: #020814;
      font-weight: 700;
      border-bottom: 6px solid #020814;
    }

  }

  .home-section-title {
    padding: 10.2vh 0 5.5vh;
    text-align: center;
    font-size: 80px;
    font-weight: 550;
    background-color: #F7F8FA;
  }

  @keyframes scaleFn {
    0% {
      transform: scale(0.5);
    }

    100% {
      transform: scale(1);
    }
  }

  .section2-item-img-1:hover {
    transform: scale(1.05);
    transition: all 0.2s linear;
  }

  .section2 {
    .home-section-title {
      background-color: #fff;
    }

    &-item-img-1 {
      margin-top: 7.4vh;
      height: 40vh;
      background: url('./images/bg5.png') center no-repeat;
      background-size: 100% 100%;
      animation: scaleFn 0.5s linear 1s 1;
    }

    &-content {
      height: 55.6vh;
      background: url('./images/section2-bg.png') center no-repeat;
      background-size: 100% 100%;
    }

    &-wrap {
      height: 100%;
      overflow: hidden;
    }

    &-item-text {
      padding-right: 5.5%;
      font-size: 32px;
      line-height: 60px;
      text-align: justify;
    }

    &-inner {
      display: flex;
      align-items: center;
      margin-top: 8.4vh;
    }

    &-controler {
      margin-top: 42vh;
      display: flex;
      justify-content: center;
    }

    &-arrow {
      margin-top: 60px;
      width: 128px;
      height: 128px;
      background: rgba(255, 255, 255, 0.5) url(./images/icon-6.png) center no-repeat;
      background-size: 48px 48px;
      cursor: pointer;
      border-radius: 50%;
    }

    &-arrow-left {
      margin-right: 120px;
      transform: rotate(180deg);
    }

    &-arrow:hover {
      background-color: #fff;
    }
  }

  .section2-inner-bg {
    position: absolute;
    left: 50%;
    bottom: 0;
    width: 0;
    height: 0;
    background: blue;
    border-radius: 60%;
    transform: translateX(-50%);

  }

  @keyframes identifierAnimation {
    10% {
      width: 10%;
      height: 20%;
      border-radius: 50%;
      bottom: -10%;
    }

    50% {
      width: 50%;
      height: 100%;
      border-radius: 50%;
      bottom: -50%;
    }

    99% {
      width: 200%;
      height: 200%;
      border-radius: 50%;
      bottom: -100%;
    }

    100% {
      width: 100%;
      height: 100%;
      border-radius: 16px;
      bottom: 0;
    }
  }

  .section2-inner-content {
    position: absolute;
    left: 0;
    top: 0;
    padding: 3.7vh 2vw;
    width: 100%;
    height: 100%;
    background: #FFFFFF;
    box-shadow: 0px 4px 16px 0px rgba(12, 56, 204, 0.1);
    border-radius: 16px;
  }

  .section2-inner-content:hover+.section2-inner-bg,
  .section2-inner-bg:hover {
    animation: identifierAnimation 0s ease-in 0s;
    padding: 3.7vh 2vw !important;
    width: 100%;
    height: 100%;
    border-radius: 16px;
    color: #fff;
  }

  .section2-inner-item-detail {
    font-weight: 400;
  }

  .section2-inner-content:hover,
  .section2-inner-bg:hover {

    .section2-inner-item-title,
    .section2-inner-item-top,
    .section2-inner-item-detail {
      color: #fff;
      transition: all 0.01s ease-in 0s;
      opacity: 1;
      font-weight: 400 !important;
    }

    .section2-inner-item-btn {
      transition: all 0s ease-in 0s;
      opacity: 1;
    }

    .section2-inner-item-detail {
      background: url(./images/icon-7.png) left center no-repeat;
    }
  }
  .section2-inner-item-title-desc{
    font-size:32px;
    font-weight: 400;
  }

  .section2-inner-bg {

    .section2-inner-item-title,
    .section2-inner-item-top,
    .section2-inner-item-detail,
    .section2-inner-item-btn {
      opacity: 0;
    }
  }

  .section2-inner {
    position: relative;
    transition: all 0.3s linear;
  }

  .section2-inner-item {
    position: relative;
    margin-right: 4.2vw;
    /* width: 32.2vw;
    min-width: 32.2vw; */
    height: 33vh;
    overflow: hidden;

    &-top {
      padding-bottom: 2.6vh;
      padding-left: 4.2vw;
      font-size: 32px;
      color: #4E5969;
      line-height: 44px;
      background: url(./images/icon-1.png) left 0 no-repeat;
      background-size: 3.1vw 3.1vw;
      border-bottom: 2px dashed #E5E6EB;
    }

    &-top-en-US {
      border-bottom: none;
      line-height: 60px;
    }

    &-top-1 {
      background: url(./images/icon-3.png) left 0 no-repeat;
      background-size: 3.1vw 3.1vw;
    }

    &-top-2 {
      background: url(./images/icon-4.png) left 0 no-repeat;
      background-size: 3.1vw 3.1vw;
    }

    &-top-3 {
      background: url(./images/icon-5.png) left 0 no-repeat;
      background-size: 3.1vw 3.1vw;
    }

    &-title {
      padding-bottom: 32px;
      font-size: 48px;
      font-weight: 700;
      color: #020814;
    }

    &-bot {
      margin-top: 2.6vh;
      display: flex;
    }

    &-btn {
      margin-right: 40px;
      width: 3.4vw;
      height: 48px;
      line-height: 48px;
      text-align: center;
      font-weight: 700;
      font-size: 24px;
      color: #020814;
      background: #F2F3F5;
      border-radius: 60px;
    }

    &-detail {
      padding-left: 52px;
      margin-bottom: 10px;
      font-size: 32px;
      color: #020814;
      line-height: 56px;
      background: url(./images/icon-2.png) left center no-repeat;
    }

  }

  .section-padding {
    padding: 0 3vw;
  }

  .section1 {
    &-item {
      flex: 1;
      justify-content: center;
      height: 15.8vh;
      font-size: 32px;

      &-num {
        padding-bottom: 2vh;
        line-height: 1;
        font-weight: 700;
        font-size: 88px;
        color: #020814;
      }

      &-unit {
        font-weight: 700;
        font-size: 28px;
        color: #020814;
      }
    }
  }

  /* 解决方案部分样式 */
  .company-title {
    padding-bottom: 4vh;
    font-weight: 550;
    font-size: 80px;
    line-height: 88px;
  }

  .company-detail {
    font-size: 36px;
  }

  .custom-indicators button {
    /* 自定义指示器的样式 */
    margin: 0 5px;
    padding: 5px;
    background-color: red;
    border: none;
    cursor: pointer;
  }

  .custom-indicators button.active {
    background-color: #409EFF;
    color: white;
  }
  .section2-inner-item-top-mobile{
    background: none;
  }
</style>